export const aboutUsMenu = [
  {
    name: "Company Introduction",
    id: 999999991,
    index: "/about/company",
    anchorName: 1,
  },
  {
    name: "Brand Mission and Vision",
    id: 999999994,
    index: "/about/mission",
    anchorName: 2,
  },
  // {
  //   name: "Why Us",
  //   id: 999999995,
  //   index: '/WhyUs',
  //   anchorName: 3,
  // },
  {
    name: "Contact Us",
    id: 999999996,
    index: "/about/contact",
    anchorName: 4,
  },
  {
    name: "Industry Dynamics",
    id: 999999997,
    index: "/about/dynamics",
    anchorName: 4,
  },
];
export const productsServiceMenu = [
  {
    name: "Mold Custom",
    id: 999999997,
    index: "/MoldCustom",
    anchorName: "moldCustomId",
  },
  {
    id: 99999999,
    name: "3D Printing",
    index: "/Printing",
    anchorName: "Printing",
  },
  {
    name: "Mold Accessories",
    id: 999999999,
    index: "/MoldAccessories",
    anchorName: "moldAccessoriesId",
  },
  {
    name: "Product Manufacturing",
    id: 9999999910,
    index: "/ProductManufacturing",
    anchorName: "productManufacturingId",
  },
  // {
  //   name: 'After-Sale Service',
  //   path: '',
  //   id: 9999999911,
  //   index: '/worldInsertCharts',
  //   anchorName: 'worldInsertCharts',
  //   jumpType: 1
  // },
];
export const suppliersMenu = [
  {
    name: "Steel",
    category: "steel",
    id: 1,
  },
  {
    name: "Hot Runner",
    category: "hot-runner",
    id: 2,
  },
  {
    name: "Spare Parts",
    id: 3,
    category: "spare-parts",
  },
  {
    name: "Die Set",
    id: 4,
    category: "die-set",
  },
];
export const capacityMenu = [
  {
    name: "Advanced Technology",
    id: 9999999912,
    index: "/home/after-sale-service",
  },
  {
    name: "Design Capability",
    id: 9999999913,
    index: "/home/after-sale-service",
  },
  {
    name: "Centralized Procurement",
    id: 9999999914,
    index: "/home/after-sale-service",
  },
  {
    name: "Manufacturing Plants",
    id: 9999999915,
    index: "/home/after-sale-service",
  },
  {
    name: "Project Management",
    id: 9999999916,
    index: "/home/after-sale-service",
  },
  {
    name: "AR Remote Die Test and Acceptance Check",
    id: 9999999917,
    index: "/home/after-sale-service",
  },
  {
    name: "Quality Guarantee",
    id: 9999999918,
    index: "/home/after-sale-service",
  },
  {
    name: "Golobal After-sale(Collabrative)",
    id: 9999999919,
    index: "/home/after-sale-service",
  },
];
